import moment from 'moment';
import i18n from '../../languages';

const modulePrefix = 'locale/';

const LOCALE_SET_SELECTED = modulePrefix + 'set_selected';

export const LOCALE_LOAD = modulePrefix + 'load';
export const LOCALE_SET = modulePrefix + 'set';

export default {
    state: {
        labels: {
            'nl': 'Nederlands',
            'fr': 'Français'
        },
        selected: localStorage.getItem('lang') || i18n.fallbackLocale,
    },
    mutations: {
        [LOCALE_SET_SELECTED](state, lang) {
            console.log('[ Locale ]', 'Changing locale to', lang);
            if (!state.labels[lang]) {
                console.log('[ Locale ]', 'Unknown locale, falling back to default');
                lang = i18n.fallbackLocale;
            }
            // Save the selected language code on the state
            state.selected = lang;
            // Apply language code to libraries
            document.querySelector('html').setAttribute('lang', lang);
            i18n.locale = lang;
            moment.locale(lang);
            // Save language in local storage for persistence
            localStorage.setItem('lang', lang);
        },
    },
    actions: {
        // Initialize the selected language from local storage
        [LOCALE_LOAD]({commit}) {
            commit(LOCALE_SET_SELECTED, localStorage.getItem('lang') || i18n.fallbackLocale);
        },
        // Change the active locale
        [LOCALE_SET]({commit, state}, language) {
            commit(LOCALE_SET_SELECTED, language);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/locale.js